import styled from "styled-components";

const Item = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 0;
  color: rgb(181, 227, 255);
  font-size: 12px;
  cursor: pointer;
  padding: 0 4px;
`;

const Img = styled.img`
  width: 14px;
  height: 14px;
`;

const WalletStatusItem = ({
  onPress,
  imgSrc,
  title,
}: {
  onPress?: () => void;
  imgSrc?: string;
  title?: string;
}) => (
  <Item type="button" onClick={onPress}>
    {imgSrc ? <Img src={imgSrc} alt="" /> : null}
    <span>{title}</span>
  </Item>
);

export default WalletStatusItem;
